import {
  Button,
  Card,
  Grid,
  InputItem,
  List,
  Modal,
  Toast,
  WhiteSpace,
  WingBlank,
} from "antd-mobile";
import { ProductionTaskGroupDTO } from "../schema";
import React, { useCallback, useEffect, useState } from "react";
import instance from "../../../util/axios";
import { Result } from "../../../schema";
import DictionarySelect from "../../../component/CheckBoxItem";

export default function Task(): JSX.Element {
  const [data, setData] = useState<ProductionTaskGroupDTO[]>([]);
  const [submitForm, setSubmitForm] = useState<{
    visible: boolean;
    count?: string;
    userId?: string;
    procedureId?: string;
    date?: string;
    workshopId?: string;
    orderId?: string;
    orderDetailId?: string;
    bomDetailId?: string;
    maxCount?: string;
  }>({
    visible: false,
  });

  const load = useCallback(() => {
    instance
      .get<Result<ProductionTaskGroupDTO[]>>(
        `/erp/production-tasks/mobile-groups`
      )
      .then((resp) => {
        if (resp.data.Status === "1") {
          setData(resp.data.Data);
        } else {
          Toast.fail(resp.data.Message);
        }
      });
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <>
      {data.map((item) => (
        <WingBlank size="lg">
          <WhiteSpace size="lg" />
          <Card>
            <Card.Header
              title={item.datetime}
              extra={<span>{item.orderNo}</span>}
            />
            <Card.Body>
              <Grid
                square={false}
                hasLine={false}
                data={[
                  {
                    text: item.workshopName,
                  },
                  {
                    text: item.procedureName,
                  },
                  {
                    text: "总数：" + item.count,
                  },
                  {
                    text: "已分配：" + item.assignedCount,
                  },
                  {
                    text: "图号:" + item.formulaName,
                  },
                  {
                    text: item.radName,
                  },
                  {
                    text: item.model,
                  },
                  {
                    text: item.centerSpacing,
                  },
                  {
                    text: item.colorName,
                  },
                  {
                    text: item.caliberName,
                  },
                  {
                    text: item.bomDetailId ? "物料：" + item.skuName : "",
                  },
                  {
                    text: item.skuModel,
                  },
                  {
                    text: item.skuStyle,
                  },
                ]}
                columnNum={2}
              />
            </Card.Body>
            <Card.Footer
              content={
                <>
                  <table style={{ width: "100%" }}>
                    <tr>
                      <td>
                        <Button
                          icon="check-circle-o"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSubmitForm({
                              visible: true,
                              procedureId: item.procedureId,
                              workshopId: item.workshopId,
                              date: item.datetime,
                              orderId: item.orderId,
                              orderDetailId: item.orderDetailId,
                              bomDetailId: item.bomDetailId || "",
                              userId: "",
                              count: item.count - item.assignedCount + "",
                              maxCount: item.count - item.assignedCount + "",
                            });
                          }}
                        >
                          分配
                        </Button>
                      </td>
                    </tr>
                  </table>
                </>
              }
            />
          </Card>
          <WhiteSpace size="lg" />
        </WingBlank>
      ))}
      <Modal
        title={"分配"}
        visible={submitForm.visible}
        onClose={() =>
          setSubmitForm({
            visible: false,
          })
        }
        transparent
        maskClosable={false}
        closable={true}
        footer={[
          {
            text: "确定",
            onPress: async () => {
              if (!submitForm.count) {
                Toast.fail(`分配数量有误`);
                return;
              }
              if (!submitForm.userId) {
                Toast.fail(`请选择要分配的生产员工！`);
                return;
              }

              if (
                parseInt(submitForm.count) >
                parseInt(submitForm.maxCount || "0")
              ) {
                Toast.fail(
                  `分配数量不得大于可分配数量：${submitForm.maxCount}`
                );
                return;
              }
              const resp = await instance.put(
                `/erp/production-tasks/assign?date=${submitForm.date}&userId=${submitForm.userId}&procedureId=${submitForm.procedureId}&count=${submitForm.count}&workshopId=${submitForm.workshopId}&orderId=${submitForm.orderId}&orderDetailId=${submitForm.orderDetailId}&bomDetailId=${submitForm.bomDetailId}`
              );
              if (resp.data.Status === "1") {
                Toast.success(`操作成功！`);
              } else {
                Toast.fail(resp.data.Data);
              }
              setSubmitForm({
                visible: false,
              });
              load();
            },
          },
        ]}
      >
        <List>
          <DictionarySelect
            title={"生产员工："}
            multiple={true}
            dictionary={"base_staff"}
            value={submitForm.userId}
            onChange={(value) => {
              setSubmitForm((prevState) => ({
                ...prevState,
                userId: value,
              }));
            }}
          />
        </List>
        <List>
          <InputItem
            min={0}
            type={"digit"}
            value={submitForm.count}
            onChange={(value) =>
              setSubmitForm((prevState) => ({
                ...prevState,
                count: value,
              }))
            }
          >
            分配数量：
          </InputItem>
        </List>
      </Modal>
    </>
  );
}
